import React, { PropsWithChildren } from 'react';
import { withStyles, WithStyles, createStyles, Theme, Hidden } from '@material-ui/core';

interface IProps {}

const styles = (theme: Theme) => createStyles<ClassKey, {}>({
    root: {}
})

type ClassKey = 'root'
type PropsType = IProps & WithStyles<ClassKey>

const MobileOnly: React.FC<PropsType & PropsWithChildren> = (props) => {
    const { children } = props;
    return (
        <Hidden only={['md', 'lg', 'xl']}>
            {children}
        </Hidden>
    )
}

export default withStyles(styles)(MobileOnly)